"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Unauthenticated = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(Unauthenticated, _Error);
  var _super = _createSuper(Unauthenticated);
  function Unauthenticated(message) {
    var _this;
    (0, _classCallCheck2.default)(this, Unauthenticated);
    _this = _super.call(this, message);
    _this.name = 'FunkeUnauthenticated';
    _this.toRedirect = true;
    _this.loginType = '';
    return _this;
  }
  return Unauthenticated;
}(/*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
var _default = exports.default = Unauthenticated;